import {
  formEventDatabase,
  waitForFormEventWrites,
} from "../FormLib/v2/use-form-events";

async function readEvents(formId?: string) {
  await waitForFormEventWrites();
  return formEventDatabase.transaction(["events"], "readonly", (tx) => {
    const store = tx.objectStore("events");
    return formId === undefined
      ? store.getAll()
      : store.index("formId").getAll(formId);
  });
}

/** window.__wombat.events commands; an optional form ID limits either command. */
export const eventsBrowserApi = {
  async print(formId?: string) {
    const events = await readEvents(formId);
    // oxlint-disable-next-line no-console
    console.log(events);
    return events;
  },
  async export(formId?: string) {
    const events = await readEvents(formId);
    const blob = new Blob([JSON.stringify(events, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `wombat-form-events-${new Date().toISOString().replace(/[:.]/g, "-")}.json`;
    document.body.appendChild(link);
    try {
      link.click();
    } finally {
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    return events;
  },
};
